import { useLocation } from 'react-router-dom';

/**
 * 获取 URL 查询参数
 * @returns 
 */
function useQueryParams(): Record<string, string> {
  const location = useLocation()
  const urlSearchParams = new URLSearchParams(location.search)
  const queryParams = Object.fromEntries(urlSearchParams.entries())
  return queryParams
}

export default useQueryParams;
